import { Component, ElementRef, ViewChild } from "@angular/core";
import Swal from 'sweetalert2';
import { TranslateService } from "@ngx-translate/core";
import { Router } from "@angular/router";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { mdlTravelCancellationInfoRes } from "../../../Models/mdlTravelCancellationInfoRes";
import { mdlStatus } from "../../../Models/CompAttachmentsMdl";
import { mdlCalculateTravelRefundRes } from "../../../Models/mdlCalculateTravelRefundRes";
import { userService } from "../../../Services/userService";
import { restURL } from "../../../Models/restURL";
import { APIService } from "../../../Services/api.service";
import { EncryptionService } from "../../../Services/EncryptionService";
import { mdlOTPReq } from "../../../Models/mdlOTPReq";
import { mdlPayloadRequest } from "../../../Models/mdlPayloadRequest";
import { mdlPayloadResponse } from "../../../Models/mdlPayloadResponse";
import { OtpVerifyReq } from "../../../Models/OtpVerifyReq";
import { environment } from "../../../environments/environment";
@Component({
    selector: "TravelCancellation",
    templateUrl: "./TravelCancellation.html",
    styleUrls: ["./TravelCancellation.css"]

})
export class TravelCancellation {
    public IsShowLoading: boolean = false;
    public UserId: string;
    public objEndReq: any;
    // public objBindInfoReq: mdlBindInfo_MotorCancel_Req = new mdlBindInfo_MotorCancel_Req();
    public objBindInfoRes: mdlTravelCancellationInfoRes = new mdlTravelCancellationInfoRes();
    public objMotorStatusMdl: mdlStatus = new mdlStatus();
    public ArabicTextFirstLetter: string;
    public ArabicTextSecondLetter: string;
    public ArabicTextThirdLetter: string;
    public EnglishTextFirstLetter: string;
    public EnglishTextSecondLetter: string;
    public EnglishTextThirdLetter: string;
    public ShowInsuredName_En: boolean = false;
    public ShowInsuredName_Ar: boolean = false;
    public isLockFields: boolean = false;
    public isSubmitted: boolean = false;
    public Lng: string;
    public agreeTerms: boolean = false;
    public declaration: boolean = false;
    @ViewChild('txtIBAN2') txtIBAN2Element: ElementRef;
    @ViewChild('txtIBAN3') txtIBAN3Element: ElementRef;
    @ViewChild('txtIBAN4') txtIBAN4Element: ElementRef;
    @ViewChild('txtIBAN5') txtIBAN5Element: ElementRef;
    @ViewChild('txtIBAN6') txtIBAN6Element: ElementRef;
    public showOTP: boolean = false;
    public isShowTimer: boolean = false;
    public isResendShow: boolean = false;
    public timeLeft: number = 180;
    public interval;
    public OTP: string;
    public objOTPReq: mdlOTPReq = new mdlOTPReq();

    // public objBindInfoRes = new mdlTravelCancellationCalReq();
    public TravelRefundRes = new mdlCalculateTravelRefundRes();
    public FileNameWithExtension: string = "";

    public VisaRejection = "";
    public IBANCopyURL = "";
    public WrongPolDet = "";
    public objPayloadRequest: mdlPayloadRequest = new mdlPayloadRequest();
    public objPayloadResponse: mdlPayloadResponse = new mdlPayloadResponse();
    public objOtpVerifyReq: OtpVerifyReq = new OtpVerifyReq();

    constructor(private userinfo: userService, private http: HttpClient, public url: restURL, private router: Router, public translate: TranslateService, private APISer: APIService, private Decriptsrvc: EncryptionService,) {
        let sessionItem: any = sessionStorage.getItem("TrvaelCancelObj");
  
        this.objEndReq = JSON.parse(this.Decriptsrvc.DecriptObject(sessionItem));

        let lan: any;
        if (sessionStorage.getItem("Language") != null) {
            lan = sessionStorage.getItem("Language");
        } else {
            lan = "en";
        }
        this.Lng = lan;
        this.isSubmitted = true;
        this.GetBindInfo();
    }

    //<<<<<<<<<<<<<GetBindInfo START>>>>>>>>>>>>>>>>>>>>
    async GetBindInfo() {
        let req = {
            PolicyNo: this.objEndReq.PolicyNo,
            UserId: "331",
            Flag: this.Lng == "en" ? "E" : "A"
        }

        this.IsShowLoading = true;
        var APIRes = await this.APISer.ConnectAPI("/LimraEndorsements/GetTravelCancellationInfo", req)
        this.IsShowLoading = false;
        var APIStatus = APIRes[0]
        if (APIStatus.StatusCode == "F") {
            swal(APIStatus.StatusDesc, "", "error")
            return;
        }
        this.objBindInfoRes = APIRes[1];

        if (this.objBindInfoRes.st.StatusCode == "F") {
            swal(this.translate.instant(this.objBindInfoRes.st.StatusDesc), "", "error");
            this.router.navigate(['/NewDashboard/Policy']);
            return;
        }

        let IBAN = this.objBindInfoRes.PolicyDetails.SplitIBANNo.split("-");
        let today = new Date();
        this.objBindInfoRes.CancellationDate = this.ConvertToYYYYMMDD(today);
        this.objBindInfoRes.CancellationReason = 0;
        this.objBindInfoRes.IBAN1 = IBAN[0].substring(2, 4);
        this.objBindInfoRes.IBAN2 = IBAN[1];
        this.objBindInfoRes.IBAN3 = IBAN[2];
        this.objBindInfoRes.IBAN4 = IBAN[3];
        this.objBindInfoRes.IBAN5 = IBAN[4];
        this.objBindInfoRes.IBAN6 = IBAN[5];
        // this.objBindInfoRes.IDCopyImage = "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6c/Saudi_ID_card.JPG/800px-Saudi_ID_card.JPG"+`?${Math.random()}`;
        // this.objBindInfoRes.IBANCopyImage = "https://cdn.www.tipalti.com/wp-content/uploads/2022/02/IBAN-UK-Format-768x372.jpg"+`?${Math.random()}`;
        this.objBindInfoRes.RefundApplicable = 1;
        this.setBankCode(this.objBindInfoRes.IBAN2);
        this.CalculateTravelRefund();


    }
    //<<<<<<<<<<<<<GetBindInfo END>>>>>>>>>>>>>>>>>>>>

    //<<<<<<<<<<<<<SetBankCode START>>>>>>>>>>>>>>>>>>>>
    setBankCode(IBAN: string) {
        if (IBAN != "" && IBAN != undefined && IBAN != null) {
            if (IBAN.length == 4) {
                let bankCode: string = IBAN.substring(0, 2);
                if (this.objBindInfoRes.bankList.filter(t => t.BankCode == bankCode).length > 0) {
                    this.objBindInfoRes.BankCode = bankCode;
                    setTimeout(() => this.txtIBAN3Element.nativeElement.focus(), 0);
                }
                else {
                    this.objBindInfoRes.BankCode = "";
                    setTimeout(() => this.txtIBAN2Element.nativeElement.focus(), 0);
                }
            }
        }
    }
    //<<<<<<<<<<<<<SetBankCode START>>>>>>>>>>>>>>>>>>>>


    //<<<<<<<<<<<<<IBAN START>>>>>>>>>>>>>>>>>>>>
    iban1Changed(event: any) {
        if (event != "" && event != undefined && event != null) {
            if (event.length == 2) {
                setTimeout(() => this.txtIBAN2Element.nativeElement.focus(), 0);
            }
        }
    }

    iban2Changed(event: any) {
        if (event != "" && event != undefined && event != null) {
            if (event.length == 4) {
                let bankCode: string = event.substring(0, 2);
                if (this.objBindInfoRes.bankList.filter(t => t.BankCode == bankCode).length > 0) {
                    this.objBindInfoRes.BankCode = bankCode;
                    setTimeout(() => this.txtIBAN3Element.nativeElement.focus(), 0);
                }
                else {
                    this.objBindInfoRes.BankCode = "";
                    setTimeout(() => this.txtIBAN2Element.nativeElement.focus(), 0);
                }
            }
        }
    }

    iban3Changed(event: any) {
        if (event != "" && event != undefined && event != null) {
            if (event.length == 4) {
                setTimeout(() => this.txtIBAN4Element.nativeElement.focus(), 0);
            }
        }
    }

    iban4Changed(event: any) {
        if (event != "" && event != undefined && event != null) {
            if (event.length == 4) {
                setTimeout(() => this.txtIBAN5Element.nativeElement.focus(), 0);
            }
        }
    }

    iban5Changed(event: any) {
        if (event != "" && event != undefined && event != null) {
            if (event.length == 4) {
                setTimeout(() => this.txtIBAN6Element.nativeElement.focus(), 0);
            }
        }
    }
    //<<<<<<<<<<<<<IBAN END>>>>>>>>>>>>>>>>>>>>



    //<<<<<<<<<<<<<Validate Special Characters START>>>>>>>>>>>>>>

    ValidateSpecialCharacters(event: any) {
        var k;
        k = event.charCode;  //         k = event.keyCode;  (Both can be used)
        return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
    }

    //<<<<<<<<<<<<<Validate Special Characters END>>>>>>>>>>>>>>






    Back() {
        this.router.navigate(['/NewDashboard/Policy']);
    }

    ConvertToYYYYMMDD(date: Date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day].join('-');
    }

    ChooseFile(event: any, FileType: string) {
        if (event.target.files && event.target.files[0]) {
            var FileSize = event.target.files[0].size / 1048576;
            this.FileNameWithExtension = event.target.files[0].name;
            var FileExtension = this.FileNameWithExtension.substring(this.FileNameWithExtension.lastIndexOf(".") + 1);
            if (FileSize > 2) {
                swal("", "File Size Should not exceed 2 MB", "error");
                return;
            }
            if (FileExtension.toString().toUpperCase() != "JPG" && FileExtension.toString().toUpperCase() != "PNG" && FileExtension.toString().toUpperCase() != "JPEG") {
                swal("Invalid File", "", "error");
                return;
            }
            this.FileNameWithExtension = this.objBindInfoRes.PolicyDetails.PolicyNo + "_B2C_TravelCancellation_" + FileType + '.' + FileExtension;
            this.UploadFile2(event.target.files[0], this.FileNameWithExtension, FileType)
        }

    }

    UploadFile2(file: File, fileName: string, FileType: string) {
        var param = environment;              
        if (!param.St.StatusDesc) {
            throw new Error("Encryption key is not initialized.");
        }

        var UserName = this.Decriptsrvc.EncriptPayload(JSON.stringify(param.Master.Code));
        var Password = this.Decriptsrvc.EncriptPayload(JSON.stringify(param.Master.Description));

        this.IsShowLoading = true;
        var fd = new FormData();
        fd.append("file", file);
        fd.append("FILENAME", fileName)
        let httpOptions: any;
        var header: HttpHeaders = new HttpHeaders();
        header.delete('Content-Type');
        header.set('enctype', "multipart/form-data");
        header = header.append('Accept-Encoding', 'gzip');
        header = header.append('apiToken', "");
        header = header.append("Authorization", "Basic " + btoa(UserName + ':' + Password));
        httpOptions = { headers: header };
        this.http.post<mdlStatus>(this.url.baseURL + "Upload/UploadTravelCancellation", fd, httpOptions).toPromise().then(
            async (res: any) => {
                if (res.StatusCode != "S") {
                    swal(res.StatusDesc, "", "error")

                    if (FileType == "WrongPolDet") {
                        this.objBindInfoRes.IDCopyImage = "";
                        this.WrongPolDet = "";
                    }
                    if (FileType == "VisaRejection") {
                        this.objBindInfoRes.IDCopyImage = "";
                        this.VisaRejection = "";
                    }
                    if (FileType == "IBANCopy") {
                        this.objBindInfoRes.IBANCopyImage = "";
                        this.IBANCopyURL = "";
                    }
                }
                else {
                    swal(res.StatusDesc, "", "success");

                    if (FileType == "VisaRejection") {
                        this.objBindInfoRes.IDCopyImage = fileName;
                        this.VisaRejection = this.url.TravelCancellationAttachment + fileName + `?${Math.random()}`;
                    }
                    if (FileType == "WrongPolDet") {
                        this.objBindInfoRes.IDCopyImage = fileName;
                        this.WrongPolDet = this.url.TravelCancellationAttachment + fileName + `?${Math.random()}`;
                    }
                    if (FileType == "IBANCopy") {
                        this.objBindInfoRes.IBANCopyImage = fileName + `?${Math.random()}`;
                        this.IBANCopyURL = this.url.TravelCancellationAttachment + fileName + `?${Math.random()}`;
                    }
                }
            },
            (error) => {
                swal(error.message, "", "error")
            });
        this.IsShowLoading = false;
    }

    OpenLarge(url: string) {
        window.open(url, "_blank");
    }

    async CalculateTravelRefund() {
        let req = {
            PolicyNo: this.objEndReq.PolicyNo,
            CancellationDate: this.objBindInfoRes.CancellationDate,
            ReFundTypeDesc: this.objBindInfoRes.RefundApplicable
        }

        this.IsShowLoading = true;
        var APIRes = await this.APISer.ConnectAPI("/LimraEndorsements/CalculateTravelRefund", req)
        this.IsShowLoading = false;
        var APIStatus = APIRes[0]
        if (APIStatus.StatusCode == "F") {
            swal(APIStatus.StatusDesc, "", "error")
            return;
        }
        this.TravelRefundRes = APIRes[1];
        if (this.TravelRefundRes.st.StatusCode == "F") {
            swal(this.translate.instant(this.TravelRefundRes.st.StatusDesc), "", "error");
            this.router.navigate(['/NewDashboard/Policy']);
            return;
        }
    }


    async Submit() {

        if (!this.objBindInfoRes.PolicyDetails.AccountName || this.objBindInfoRes.PolicyDetails.AccountName.length === 0) {
            swal(this.translate.instant("Please Enter Bank Account Holder name"), "", "error");
            return;
        }

        let IBANNumber = "SA" + this.objBindInfoRes.IBAN1 + this.objBindInfoRes.IBAN2 + this.objBindInfoRes.IBAN3 +
            this.objBindInfoRes.IBAN4 + this.objBindInfoRes.IBAN5 + this.objBindInfoRes.IBAN6;

        let req = {
            PolicyNo: this.objEndReq.PolicyNo,
            CancellationDate: this.objBindInfoRes.CancellationDate,
            CancellationReasonCode: this.objBindInfoRes.CancellationReason,
            IBANNumber: IBANNumber,
            BankCode: this.objBindInfoRes.BankCode,
            UserId: this.UserId,
            IDCopyImage: this.objBindInfoRes.IDCopyImage,
            IBANCopyImage: this.objBindInfoRes.IBANCopyImage,
            InsuredID:this.objBindInfoRes.PolicyDetails.Insured_IDNo,
            AccountName:this.objBindInfoRes.PolicyDetails.AccountName
        }

        this.IsShowLoading = true;
        var APIRes = await this.APISer.ConnectAPI("/TravelNewPortal/SubmitTravelCancellation", req)
        this.IsShowLoading = false;
        var APIStatus = APIRes[0]
        if (APIStatus.StatusCode == "F") {
            swal(APIStatus.StatusDesc, "", "error")
            return;
        }
        var Res = APIRes[1];
        if (Res.st.StatusCode == "S") {
            swal(Res.st.StatusDesc, "", "success");
            this.router.navigate(['/NewDashboard/Policy']);
            return;
        } else {
            swal('', APIRes[1].st.StatusDesc, "error")
            return;
        }
    }


    Direction(): Object {
        if (this.Lng == "ar") {
            return { 'direction': 'rtl' }
        }
        return {}
    }


    SendOtpCanellation() {
        if (this.objBindInfoRes.CancellationReason == 0) {
            swal(this.translate.instant("Please Select Cancellation Reason"), "", "error");
            return;
        }
        if (this.objBindInfoRes.BankCode == undefined || this.objBindInfoRes.BankCode == null || this.objBindInfoRes.BankCode.trim() == "") {
            swal(this.translate.instant("Bank Name is required"), "", "error");
            return;
        }

        if (this.objBindInfoRes.CancellationReason == 5) {
            if (this.objBindInfoRes.IDCopyImage == undefined || this.objBindInfoRes.IDCopyImage == null || this.objBindInfoRes.IDCopyImage.trim() == "") {
                Swal(this.translate.instant("Please Upload Wrong Policy Details Copy"), "", "error");
                return;
            }
        }
        if (this.objBindInfoRes.CancellationReason == 12) {
            if (this.objBindInfoRes.IDCopyImage == undefined || this.objBindInfoRes.IDCopyImage == null || this.objBindInfoRes.IDCopyImage.trim() == "") {
                Swal(this.translate.instant("Please Upload Visa Rejection Copy"), "", "error");
                return;
            }
        }
 
        if (this.objBindInfoRes.IBANCopyImage == undefined || this.objBindInfoRes.IBANCopyImage == null || this.objBindInfoRes.IBANCopyImage.trim() == "") {
            Swal(this.translate.instant("Please Upload IBANCopy"), "", "error");
            return;
        }

        let IBANNumber = "SA" + this.objBindInfoRes.IBAN1 + this.objBindInfoRes.IBAN2 + this.objBindInfoRes.IBAN3 +
            this.objBindInfoRes.IBAN4 + this.objBindInfoRes.IBAN5 + this.objBindInfoRes.IBAN6;

        if (IBANNumber.length < 24) {
            swal(this.translate.instant("IBAN Number must be 24 digits"), "", "error");
            return;
        }
        this.SendOTP();
    }
    CancellationReasonChange() { 
        this.objBindInfoRes.IDCopyImage = "";
        this.VisaRejection="";
        this.WrongPolDet="";
    }

    //<<<<<<<<<<<<<Submit Cancellation START>>>>>>>>>>>>>>>>>>>>
    SendOTP() {

        this.IsShowLoading = true;
        this.objOTPReq.RegNo = parseInt(sessionStorage.getItem("RegNo")),
            this.objOTPReq.MobileNo = this.objBindInfoRes.PolicyDetails.Insured_MobileNo,
            this.objOTPReq.EmailId = this.objBindInfoRes.PolicyDetails.Insured_EmailId,
            this.objOTPReq.Lng = this.Lng

        this.objPayloadRequest.Payload = this.Decriptsrvc.EncriptPayload(JSON.stringify(this.objOTPReq));

        //this.http.post<MotorStatusMdl>(this.url.baseURL + "/Motor_Cancellation/SendOTP_Motor_Cancellation", this.objBindInfoRes, this.userinfo.getHttpOptions()).toPromise().then((result) => {
        this.http.post<mdlPayloadResponse>(this.url.baseURL + "/TravelNewPortal/CancelOTPReq", this.objPayloadRequest, this.userinfo.getHttpOptions()).toPromise().then((result) => {
            this.IsShowLoading = false;
            //this.objMotorStatusMdl = result;

            //New Line Start
            this.objPayloadResponse = result;
            this.objMotorStatusMdl = JSON.parse(JSON.stringify(this.Decriptsrvc.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
            //NewLine End

            swal(this.Lng == "en" ? this.objMotorStatusMdl.StatusDesc : this.objMotorStatusMdl.StatusDescAr);
            if (this.objMotorStatusMdl.StatusCode == "S") {
                this.isLockFields = true;
                this.showOTP = true;
                this.showOTPTimer();
            }
        }, (error) => {
            this.IsShowLoading = false;
            this.userinfo.checkTokenStatus(error);

        });

    }
    //<<<<<<<<<<<<<Submit Cancellation END>>>>>>>>>>>>>>>>>>>>





    //<<<<<<<<<<<<<showOTPTimer OTP START>>>>>>>>>>>>>>>>>>>>
    showOTPTimer() {
        this.isShowTimer = true;
        this.interval = setInterval(() => {
            if (this.timeLeft > 0) {
                this.timeLeft--;
            } else if (this.timeLeft == 0) {
                this.timeLeft = 0;
                this.isResendShow = true;
            } else {
                this.timeLeft = 180;
            }
        }, 1000)
    }
    //<<<<<<<<<<<<<showOTPTimer OTP END>>>>>>>>>>>>>>>>>>>>



    //<<<<<<<<<<<<<VERIFY OTP START>>>>>>>>>>>>>>>>>>>>
    VerifyOTP() {

        if (this.objBindInfoRes.CancellationReason == 0) {
            swal(this.translate.instant("Please Select Cancellation Reason"), "", "error");
            return;
        }
        if (this.objBindInfoRes.BankCode == undefined || this.objBindInfoRes.BankCode == null || this.objBindInfoRes.BankCode.trim() == "") {
            swal(this.translate.instant("Bank Name is required"), "", "error");
            return;
        }
        let IBANNumber = "SA" + this.objBindInfoRes.IBAN1 + this.objBindInfoRes.IBAN2 + this.objBindInfoRes.IBAN3 +
            this.objBindInfoRes.IBAN4 + this.objBindInfoRes.IBAN5 + this.objBindInfoRes.IBAN6;

        if (IBANNumber.length < 24) {
            swal(this.translate.instant("IBAN Number must be 24 digits"), "", "error");
            return;
        }

        if (this.OTP == null) {
            this.Lng == "ar" ? swal("برجاء إدخال رمز التفعيل") : swal("Please Enter Valid OTP");
            return;
        }
        this.objOtpVerifyReq.OTP = this.OTP;
        this.objOtpVerifyReq.RegNo = Number(sessionStorage.getItem("RegNo"));
        this.IsShowLoading = true;

        this.objPayloadRequest.Payload = this.Decriptsrvc.EncriptPayload(JSON.stringify(this.objOtpVerifyReq));

        //this.http.post<MotorStatusMdl>(this.url.baseURL + "/Motor_Cancellation/Verify_Motor_Cancellation", this.objOtpVerifyReq, this.userinfo.getHttpOptions()).toPromise().then((result) => {
        this.http.post<mdlPayloadResponse>(this.url.baseURL + "/Motor_Cancellation/Verify_Motor_Cancellation", this.objPayloadRequest, this.userinfo.getHttpOptions()).toPromise().then((result) => {
            this.IsShowLoading = false;
            //this.objMotorStatusMdl = result;

            //New Line Start
            this.objPayloadResponse = result;
            this.objMotorStatusMdl = JSON.parse(JSON.stringify(this.Decriptsrvc.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
            //NewLine End

            if (this.objMotorStatusMdl.StatusCode == "S") {
                this.showOTP = false;
                clearInterval(this.interval);
                this.timeLeft = 180;
                this.OTP = "";
                this.isShowTimer = false;
                this.Submit();
            }
            else {
                swal(this.Lng == "en" ? this.objMotorStatusMdl.StatusDesc : this.objMotorStatusMdl.StatusDescAr);
            }

        }, (error) => {
            this.IsShowLoading = false;
            this.userinfo.checkTokenStatus(error);
        });
    }
    //<<<<<<<<<<<<<VERIFY OTP END>>>>>>>>>>>>>>>>>>>>

    allowEnglishOnly(event: KeyboardEvent) {
        const char = String.fromCharCode(event.keyCode);
        const pattern = /^[A-Za-z ]+$/;
        if (!pattern.test(char)) {
            swal(this.translate.instant("Please Enter English Name only"));
            event.preventDefault();
        }
    }

}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/TravelPortal/TravelCancellation/TravelCancellation.ts